import React from "react"
import SEO from "../components/SEO"
import PageIllustration from "../partials/PageIllustration"
import HeroHome from "../partials/HeroHome"
import FeaturesZigzag from "../partials/FeaturesZigzag"
import TestimonialsCarousel from "../partials/TestimonialsCarousel"
import Cta from "../partials/Cta"
import Stats from "../partials/Stats"
import News from "../partials/News"
import TrustedBy from "../partials/TrustedBy"
import Partners from "../partials/Partners"
import CalendlyBook from "../partials/CalendlyBook"
import VideoReviews from "../partials/VideoReviews"
import Faqs from "../partials/Faqs"
import ProcessSecurity from "../partials/ProcessSecurity"
import HomeFeaturesTabs from "../partials/HomeFeaturesTabs"
import ProcessTeamCollaboration from "../partials/ProcessTeamCollaboration"
import HallOfFame from "../partials/HallOfFame"

function Home() {
  return (
    <>
      <SEO {...{ pageType: "blogPage" }} />
      {/*  Page content */}
      <main className="flex-grow">
        {/*  Page illustration */}
        <div
          className="relative max-w-6xl mx-auto h-0 pointer-events-none"
          aria-hidden="true"
        >
          <PageIllustration />
        </div>

        {/*  Page sections */}
        <HeroHome />
        <HomeFeaturesTabs />

        <FeaturesZigzag />
        <ProcessSecurity />

        <TrustedBy />
        <TestimonialsCarousel />
        <Stats />
        <HallOfFame />
        <Cta />
        <ProcessTeamCollaboration />
        <VideoReviews />
        <Partners />
        <Faqs />
        <News />
        <CalendlyBook />
      </main>
    </>
  )
}

export default Home
